<template>
  <div class="fillup-register container kanit">
    <div v-if="dismissCountDown && stepPage === 'fillupPage'" class="alert-custom">
        <i class="far fa-check-circle color-alert-has-cus"></i>
        <span class="color-alert-has-cus">
            {{ messageAlert }}
        </span>
    </div>
    <div v-if="stepPage === 'fillupPage'" class="d-flex flex-column mt-2 position-relative">
        <div :class="dismissCountDown ? 'mt-5' : ''">
            <label class="" for="namelastname">ชื่อ-นามสกุล</label>
            <b-form-input type="text" placeholder="กรอกชื่อของคุณ" v-model="groupinput.name" :class="{ 'is-invalid': $v.groupinput.name.$error }"/>
            <div v-if="$v.groupinput.name.$error">
                <p v-if="!$v.groupinput.name.required" class="invalid-feedback d-block">กรุณากรอกชื่อ-นามสกุล</p>
            </div>
            <label class="mt-2" for="phoneNumber">เบอร์โทรศัพท์</label>
            <b-form-input class="text-muted" type="text" placeholder="กรุณากรอกเบอร์โทรศัพท์" v-model="groupinput.phoneNumber" disabled />
            <div class="w-100">
                <label class="mt-2" for="dateBirthday">วันเดือนปีเกิด (รับสิทธิพิเศษ)</label>
                <input class="form-control w-100" type="date" v-model="groupinput.dateBirthday" />
            </div>
            <div class="d-flex justify-content-between my-3">
                <div class="select-option cursor-pointer border-selected-type d-flex align-items-center px-2 mr-1" :class="groupinput.typeID === 'person' ? 'active-box' : ''" @click="changeTypeID('person')">
                    <span class="font-13px text-nonwrap text-align-center m-auto">เลขบัตรประชาชน (ID Card)</span>
                </div>
                <div class="select-option cursor-pointer border-selected-type d-flex align-items-center px-2" :class="groupinput.typeID === 'passport' ? 'active-box' : ''" @click="changeTypeID('passport')">
                    <span class="font-13px text-nonwrap text-align-center m-auto">เลขพาสปอร์ต (Passport)</span>
                </div>
            </div>
            <div>
                <div v-if="groupinput.typeID === 'person'">
                    <label for="fillupID">เลขบัตรประชาชน</label>
                    <b-form-input type="text" placeholder="กรุณากรอกเลขบัตรประชาชน" @input="checkPersonNumber" v-model="groupinput.fillUpID" :class="{ 'is-invalid': $v.groupinput.fillUpID.$error }" />
                    <div v-if="$v.groupinput.fillUpID.$error">
                        <p v-if="!$v.groupinput.fillUpID.required" class="invalid-feedback d-block">กรุณากรอกเลขบัตรประชาชน</p>
                    </div>
                    <div v-if="error.idPerson">
                        <p v-if="error.idPerson" class="invalid-feedback d-block">คุณกรอกเลขบัตรประชาชนไม่ถูกต้อง</p>
                    </div>
                </div>
                <div v-else>
                    <label for="fillupID">เลขพาสปอร์ต</label>
                    <b-form-input type="text" placeholder="กรุณากรอกเลขพาสปอร์ต" @input="isPassportNo" v-model="groupinput.fillUpID" :class="{ 'is-invalid': $v.groupinput.fillUpID.$error }" />
                    <div v-if="$v.groupinput.fillUpID.$error">
                        <p v-if="!$v.groupinput.fillUpID.required" class="invalid-feedback d-block">กรุณากรอกเลข passport</p>
                    </div>
                </div>
            </div>
            <label class="mt-2" for="address">รายละเอียดที่อยู่</label>
            <b-form-textarea rows="1" type="text" placeholder="กรอกรายละเอียดที่อยู่" v-model="from.address" :class="{ 'is-invalid': $v.from.address.$error }"  />
            <div v-if="$v.from.address.$error">
                <p v-if="!$v.from.address.required" class="invalid-feedback d-block">กรุณากรอกที่อยู่</p>
            </div>
            
            <div class="mt-3">
                <div
                    :class="{ 'is-invalid': $v.from.fakeAddress.$error }"
                    class="box-model form-control d-flex justify-content-between align-items-center cursor-pointer" @click="changeSlideOnsearch('formatAddress')">
                    <div class="cursor-pointer">
                        {{ from.fakeAddress }}
                    </div>
                    <span class="cursor-pointer">
                        <img :src="iconUrl.iconmore" />
                    </span>
                </div>
                <div v-if="$v.from.fakeAddress.$error">
                    <p v-if="!$v.from.fakeAddress.required" class="invalid-feedback d-block">กรุณาเลือกตำบล/อำเภอ/เขต/จังหวัด</p>
                </div>
            </div>
            <div class="d-flex justify-content-start mt-3">
                <div class="custom-checkbox cursor-pointer" @click="onChangeAddress">
                    <input type="checkbox" v-model="checkedNewAddress"/>
                    <div class="custom-checkbox-circle cursor-pointer">
                    </div>
                </div>
                <div class="ml-3 cursor-pointer" @click="onChangeAddress">
                    <span>
                        ที่อยู่เริ่มต้นในการจัดส่ง
                    </span>
                </div>
            </div>
            <div v-if="!checkedNewAddress" class="mt-2">
                <label class="mt-2" for="address">ที่อยู่สำหรับจัดส่ง</label>
                <b-form-textarea
                :class="{ 'is-invalid': $v.customFrom.address.$error }"
                rows="1" type="text" placeholder="กรอกรายละเอียดที่อยู่" v-model="customFrom.address" />
                <div class="mt-3">
                    <div
                        :class="{ 'is-invalid': $v.customFrom.fakeAddress.$error }"
                        class="box-model form-control d-flex justify-content-between align-items-center cursor-pointer" @click="changeSlideOnsearch('customFrom')">
                        <div class="cursor-pointer">
                            {{ customFrom.fakeAddress }}
                        </div>
                        <span class="cursor-pointer">
                            <img :src="iconUrl.iconmore" />
                        </span>
                    </div>

                    <div v-if="$v.customFrom.fakeAddress.$error">
                        <p v-if="!$v.customFrom.fakeAddress.required" class="invalid-feedback d-block">กรุณาเลือกตำบล/อำเภอ/เขต/จังหวัด</p>
                    </div>
                </div>
            </div>
            <div class="alert-noti">
                <span class="color-alert-noti">
                    <img :src="iconUrl.infoCircle" alt="">
                    กรุณาตรวจสอบความถูกต้องก่อนกดยืนยัน
                </span>
            </div>
        </div>
        <div class="fixbutton">
            <b-button block variant="line-primary" class="mt-4" @click="ActionRegister()">
                ยืนยัน
            </b-button>
        </div>
    </div>
    <div v-if="stepPage === 'address-input'">
        <label for="ที่อยู่">ค้นหาที่อยู่</label>
        <div class="thai-address-input-search">
            <thai-address-input type="search"
                v-model="fakeAddressInput"
                input-class="form-control"
                @selected="onSearchedInputGroup"
                placeholder="กรอกที่อยู่ของคุณที่นี่"
                >
            </thai-address-input>
            <div v-if="fakeAddressInput.length > 0" class="close-button" @click="clearInputfakeAddressInput">
                <i class="fas fa-times-circle" style="color: #f2f2f2;"></i>
            </div>
        </div>
        <div class="image-empty w-100 mt-5">
            <img src="../../assets/images/line/emptyaddress.png" alt="">
        </div>
        <div>
            <h1 class="header-empty">
                ค้นหาที่อยู่ของคุณ
            </h1>
            <h3 class="description-empty">
                เช่น ตำบล , อำเภอ , จังหวัด , รหัสไปรษณีย์
            </h3>
        </div>
    </div>
  </div>
</template>

<script>
const context_line = JSON.parse(localStorage.getItem('context_line'))

import { required, minLength, maxLength } from "vuelidate/lib/validators";
import {
    checkPersonID,
    validatePassportNo
} from "@/plugins/posHelper.js";

export default {
    metaInfo: {
      title: 'ลงทะเบียนเว็บไซต์',
    },
    data() {
        return {
            tempActionAddress: '',
            stepPage: 'fillupPage',
            messageAlert: '',
            groupinput:{
                name: '',
                phoneNumber: '',
                dateBirthday: '',
                typeID: 'person',
                fillUpID: '',
            },
            iconUrl: {
                infoCircle: require('../../assets/icon/info-circle.svg'),
                iconmore: require('../../assets/icon/iconmore.svg')
            },
            submitAddAddress: false,
            submitAddcustomFrom: false,
            from: {
                address: '',
                district: '',
                fakeAddress: '',
                postcode: '',
                province: '',
                state: '',
            },
            fakeAddressInput: "",
            dismissCountDown: false,
            checkedNewAddress: true,
            customFrom: {
                address: '',
                fakeAddress: '',
                district: '',
                postcode: '',
                province: '',
                state: '',
            },
            error: {
                idPerson: false,
                passport: false,
            },
            iconPhone: {
                url: require("../../assets/icon/phone.svg")
            },
        }
    },
    validations: {
        groupinput: {
            name: { required },
            phoneNumber: { required },
            fillUpID: { required },
        },
        from: {
            address: { required },
            district: { required },
            fakeAddress: { required },
            postcode: {
                required,
                minLength: minLength(5),
                maxLength: maxLength(5)
            },
            province: { required },
            state: { required },
        },
        customFrom: {
            address: { required },
            district: { required },
            fakeAddress: { required },
            postcode: {
                required,
            },
            province: { required },
            state: { required },
        },
    },
    mounted() {
        this.$liff.init({
            liffId: context_line.liffId
        })
        if(this.$route.query.phoneNumber) {
            this.groupinput.phoneNumber = this.$route.query.phoneNumber
            this.isCustomer(this.$route.query.phoneNumber)            
        }
    },
    methods: {
        changeSlideOnsearch(key) {
            this.tempActionAddress = key
            this.stepPage = 'address-input'
            this.clearInputfakeAddressInput()
        },
        clearInputfakeAddressInput() {
            this.fakeAddressInput = ""
        },
        onSearchedInputGroup(address) {
            if(this.tempActionAddress === 'formatAddress') {
                this.from.state = address.subdistrict;
                this.from.district = address.district;
                this.from.province = address.province;
                this.from.postcode = address.postalCode;
                this.from.fakeAddress = address['subdistrict'] + '>' + address['district'] + '>' + address['province'] + '>' +address['postalCode']
            }
            if(this.tempActionAddress === 'customFrom') {
                this.customFrom.state = address.subdistrict;
                this.customFrom.district = address.district;
                this.customFrom.province = address.province;
                this.customFrom.postcode = address.postalCode;
                this.customFrom.fakeAddress = address['subdistrict'] + '>' + address['district'] + '>' + address['province'] + '>' +address['postalCode']
            }
            this.fakeAddressInput = address['subdistrict'] + '>' + address['district'] + '>' + address['province'] + '>' +address['postalCode']
            this.stepPage = 'fillupPage'
        },
        isPassportNo(key) {
            return validatePassportNo(key)
        },
        checkPersonNumber(key) {
            if(!checkPersonID(key)) {
                this.error.idPerson = true
            }else {
                this.error.idPerson = false
            }
        },
        async ActionRegister() {
            this.$v.groupinput.$touch();
            console.log('this.checkedNewAddress: ', this.checkedNewAddress)
            if(this.checkedNewAddress === false) {
                this.$v.customFrom.$touch();
                if( this.$v.customFrom.$invalid ) {
                    return false
                }
            }else {
                this.$v.from.$touch();
                if( this.$v.from.$invalid ) {
                    return false
                }
            }

            // validate idperson
            if(this.groupinput.type === 'person') {
                if(this.error.idPerson === true) {
                    return false
                }
            }

            // validate passport
            if(this.groupinput.type === 'passport') {
                if(this.error.passport === true) {
                    return false
                }
            }
            
            if( this.$v.groupinput.$invalid ) {
                return false
            }

            const getProfile = JSON.parse(localStorage.getItem('profile_line'))
            const bodyRequest = {
                tel: this.groupinput.phoneNumber,
                name: this.groupinput.name,
                id_number: this.groupinput.fillUpID,
                date_of_birth: this.groupinput.dateBirthday,
                typeid: this.groupinput.typeID,
                from: this.from,
                sender_from: this.checkedNewAddress ? this.from : this.customFrom,
                userId: getProfile.sub
            }
            await this.$http.post(this.$API_URL + "/line/insert/customer", bodyRequest).then((res) => {
                console.log('result: ', res)
            })
            await this.$liff.closeWindow()

        },
        isCustomer(phone) {
            const bodyRequest = {
                access_token: localStorage.getItem("access_token_line")
            }
            this.$http.post(this.$API_URL + `/line/iscustomer/${phone}`, bodyRequest).then((res) => {
                const status = res.data.status
                const resData = res.data.data
                if(status) {
                    if(!resData) {
                        // alert not have data
                    }else {
                        // alert having data and assign value
                        this.showAlert()
                        this.groupinput.name = resData.name
                        this.groupinput.fillUpID = resData.id_number
                        this.from.address = resData.address
                        this.messageAlert = "คุณมีข้อมูลอยู่ในระบบแล้ว"
                        this.from.state = resData['state']
                        this.from.district = resData['district']
                        this.from.province = resData['province']
                        this.from.postcode = resData['postcode']
                        this.from.fakeAddress = (!resData['state'] || !resData['district'] || !resData['province'] || !resData['postcode']) ? '' : resData['state'] + ' > ' + resData['district'] + ' > ' + resData['province'] + ' > ' +resData['postcode']
                        // TODO: rename from.name to address something ด้วยจ้า
                        this.messageAlert = "กรุณาตรวจสอบความถูกต้องก่อนกดยืนยัน"
                        if(resData.id_number.length === 13) {
                            this.typeID = "person"
                        }else {
                            this.typeID = "passport"
                        }
                    }
                }
            })
        },
        onChangeAddress() {
            this.checkedNewAddress = !this.checkedNewAddress
            this.customFrom.state = ""
            this.customFrom.district = ""
            this.customFrom.province = ""
            this.customFrom.postcode = ""
            this.customFrom.fakeAddress = ""
        },
        showAlert() {
            this.dismissCountDown = true
            // let intervalId = setInterval(() => {
            //     console.log('dosomething: ', this.dismissCountDown)
            //     if(this.dismissCountDown > 0) {
            //         this.dismissCountDown--;
            //     }
            //     if(this.dismissCountDown === 0) {
            //         clearInterval(intervalId);
            //         return;
            //     }
            // }, 1000);
        },  
        changeTypeID(key) {
            this.groupinput.typeID = key
        },
    }
}
</script>

<style lang="scss" scoped>
.thai-address-input-search {
    position: relative;
    .close-button {
        position: absolute;
        top: 27% ;
        right: 15px;
    }
}
.alert-custom {
    position: absolute;
    margin-top: -2%;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 16px;
    gap: 8px;
    width: 100%;
    height: 40px;
    background: #E9F5EE;
    flex: none;
    order: 1;
    flex-grow: 0;
}
.color-alert-has-cus {
    color: #219653;
}
</style>